<script setup>
    const props = defineProps({
        title: String,
        subTitle: String,
        label: String
    });
</script>

<template>
    <div class="col-12 col-md-6 offset-md-3">
        <div class="text--center">
            <h2 class="h2-large-classic text--medium mb-3">{{ props.title }}</h2>
            <div class="fakta">
                {{ props.subTitle }}
            </div>
            <div class="fakta text--bold text--left extra-p mt-5 mb-1">
                {{ props.label }}
            </div>
            <slot></slot>
        </div>
    </div>
</template>  
